import type { StoreData } from "@features/stores/types";

export const isEccoStore = (store: StoreData) => store?.storeTypeId === "ECCO";
